export const restaurants = [
    {
        type: "restaurant",
        info: {
            resId: 19879345,
            name: "KFC",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/6/800126/9410759d611db9c62c3acc23c1f27e06_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/6/800126/9410759d611db9c62c3acc23c1f27e06_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.1",
                rating_text: "4.1",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "194",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.0",
                        reviewCount: "4",
                        reviewTextSmall: "4 Reviews",
                        subtext: "4 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.0",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.1",
                        reviewCount: "190",
                        reviewTextSmall: "190 Reviews",
                        subtext: "190 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.1",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹450 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address:
                    "Shop 25, Anchor C, Ground Floor, Saharaganj Mall, Saharaganj Road, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "Closes in 1 hour 21 minutes",
                color: "#e5521f",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/burger/",
                    name: "Burger",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/desserts/",
                    name: "Desserts",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "36 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/kfc-1-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/kfc-1-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.1 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19879345","element_type":"listing","rank":1}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "20% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "1100+ orders placed from here recently",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800228,
            name: "Marksmen",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/8/800228/b4975f178b8c9264498a65735f5d4263_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/8/800228/b4975f178b8c9264498a65735f5d4263_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.1",
                rating_text: "4.1",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "19.7K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.2",
                        reviewCount: "937",
                        reviewTextSmall: "937 Reviews",
                        subtext: "937 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.2",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.0",
                        reviewCount: "18.8K",
                        reviewTextSmall: "18.8K Reviews",
                        subtext: "18.8K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.0",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹600 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Lalbagh, Lucknow",
                address: "2, Maqbara Road, Opposite Halwasiya Market, Lalbagh, Lucknow",
                localityUrl: "lucknow/lalbagh-restaurants",
            },
            timing: {
                text: "Closes in 1 hour 51 minutes",
                color: "#e5521f",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/south-indian/",
                    name: "South Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "35 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/marksmen-lalbagh/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/marksmen-lalbagh/order",
            clickActionDeeplink: "",
        },
        distance: "1.8 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800228","element_type":"listing","rank":2}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "Pro extra 20% OFF",
                color: {
                    tint: "600",
                    type: "pink",
                },
            },
            {
                text: "20% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "7950+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800260,
            name: "McDonald's",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/0/800260/0094c2b5485c4c2f52c931306442269b_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/0/800260/0094c2b5485c4c2f52c931306442269b_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.1",
                rating_text: "4.1",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "6,586",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.2",
                        reviewCount: "1,171",
                        reviewTextSmall: "1,171 Reviews",
                        subtext: "1,171 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.2",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.0",
                        reviewCount: "5,415",
                        reviewTextSmall: "5,415 Reviews",
                        subtext: "5,415 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.0",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹500 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Sahara Ganj Mall, Hazratganj, Lucknow",
                address:
                    "4th Floor, Sahara Ganj Mall, Shahnajaf Road, Hazratganj, Lucknow",
                localityUrl: "lucknow/restaurants/in/saharaganj-mall-hazratganj",
            },
            timing: {
                text: "Closes in 1 hour 21 minutes",
                color: "#e5521f",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/burger/",
                    name: "Burger",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "36 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/mcdonalds-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/mcdonalds-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.1 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800260","element_type":"listing","rank":3}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "30% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "10250+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800561,
            name: "Mahesh's Mansarovar",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/1/800561/2b381cd36baba26fd2ec309cee7f20f6_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/1/800561/2b381cd36baba26fd2ec309cee7f20f6_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.2",
                rating_text: "4.2",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "27.8K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.2",
                        reviewCount: "1,116",
                        reviewTextSmall: "1,116 Reviews",
                        subtext: "1,116 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.2",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.1",
                        reviewCount: "26.7K",
                        reviewTextSmall: "26.7K Reviews",
                        subtext: "26.7K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.1",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹400 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Aliganj, Lucknow",
                address: "8 Commercial, Near Bank Of India, Nirala Nagar, Lucknow",
                localityUrl: "lucknow/aliganj-restaurants",
            },
            timing: {
                text: "Closes in 1 hour 51 minutes",
                color: "#e5521f",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/desserts/",
                    name: "Desserts",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mithai/",
                    name: "Mithai",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "35 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/maheshs-mansarovar-aliganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/maheshs-mansarovar-aliganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.9 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800561","element_type":"listing","rank":4}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "₹75 OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "8675+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800486,
            name: "Moti Mahal",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/6/800486/ebce2cecb33af555c7c4405ae044c663_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/6/800486/ebce2cecb33af555c7c4405ae044c663_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.2",
                rating_text: "4.2",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "13.9K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.3",
                        reviewCount: "1,214",
                        reviewTextSmall: "1,214 Reviews",
                        subtext: "1,214 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.3",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.0",
                        reviewCount: "12.7K",
                        reviewTextSmall: "12.7K Reviews",
                        subtext: "12.7K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.0",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹800 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address:
                    "Shop 75, M G Marg, Near Central Bank Of India, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/south-indian/",
                    name: "South Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/pizza/",
                    name: "Pizza",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/desserts/",
                    name: "Desserts",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "48 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/moti-mahal-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/moti-mahal-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.9 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800486","element_type":"listing","rank":5}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "₹75 OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "6575+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800623,
            name: "Alamgir Hotel",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/3/800623/db2af0909d9d47da97d29378b3d36ebc_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/3/800623/db2af0909d9d47da97d29378b3d36ebc_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.2",
                rating_text: "4.2",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "14.6K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.4",
                        reviewCount: "1,021",
                        reviewTextSmall: "1,021 Reviews",
                        subtext: "1,021 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.4",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "3.9",
                        reviewCount: "13.6K",
                        reviewTextSmall: "13.6K Reviews",
                        subtext: "13.6K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "3.9",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹350 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Aminabad, Lucknow",
                address: "Nazirabad Road, Aminabad, Lucknow",
                localityUrl: "lucknow/aminabad-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "36 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/alamgir-hotel-aminabad/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/alamgir-hotel-aminabad/order",
            clickActionDeeplink: "",
        },
        distance: "2.9 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800623","element_type":"listing","rank":6}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "50% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "5275+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800301,
            name: "Aadab-e-Dastarkhwan",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/1/800301/207ed2ffee3ba2300464c26b15ba1b0d_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/1/800301/207ed2ffee3ba2300464c26b15ba1b0d_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.2",
                rating_text: "4.2",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "10.9K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.3",
                        reviewCount: "585",
                        reviewTextSmall: "585 Reviews",
                        subtext: "585 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.3",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.0",
                        reviewCount: "10.3K",
                        reviewTextSmall: "10.3K Reviews",
                        subtext: "10.3K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.0",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹600 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Indira Nagar, Lucknow",
                address: "Basement, Umrao Plaza, Indira Nagar, Lucknow",
                localityUrl: "lucknow/indira-nagar-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTU3XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/lucknowi/",
                    name: "Lucknowi",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "40 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/aadab-e-dastarkhwan-indira-nagar/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/aadab-e-dastarkhwan-indira-nagar/order",
            clickActionDeeplink: "",
        },
        distance: "3.2 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800301","element_type":"listing","rank":7}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "₹75 OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "8175+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 18877935,
            name: "La Pino'z Pizza",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/0/18798800/7c9f7c11939dcfdf4602edaa44329167_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/0/18798800/7c9f7c11939dcfdf4602edaa44329167_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.2",
                rating_text: "4.2",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "33.1K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.4",
                        reviewCount: "737",
                        reviewTextSmall: "737 Reviews",
                        subtext: "737 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.4",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.0",
                        reviewCount: "32.4K",
                        reviewTextSmall: "32.4K Reviews",
                        subtext: "32.4K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.0",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹800 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address: "1, Sapru Marg, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/pizza/",
                    name: "Pizza",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "34 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/la-pinoz-pizza-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/la-pinoz-pizza-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.2 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18877935","element_type":"listing","rank":8}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "60% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "16450+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 19270356,
            name: "Burger King",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/3/19165593/9f2f843523d0e8b9ecd9ee9ee32c1c46_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/3/19165593/9f2f843523d0e8b9ecd9ee9ee32c1c46_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.2",
                rating_text: "4.2",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "7,572",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.3",
                        reviewCount: "494",
                        reviewTextSmall: "494 Reviews",
                        subtext: "494 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.3",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.1",
                        reviewCount: "7,078",
                        reviewTextSmall: "7,078 Reviews",
                        subtext: "7,078 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.1",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹350 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address: "GF, Sahu The Theatre Building, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/burger/",
                    name: "Burger",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "47 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/burger-king-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/burger-king-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.7 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19270356","element_type":"listing","rank":9}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "60% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "8175+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800279,
            name: "Grandson of Tunday Kababi",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/9/800279/8abdada7f34c0384e98473c4092c6076_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/9/800279/8abdada7f34c0384e98473c4092c6076_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.1",
                rating_text: "4.1",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "6,831",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.2",
                        reviewCount: "438",
                        reviewTextSmall: "438 Reviews",
                        subtext: "438 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.2",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "3.9",
                        reviewCount: "6,393",
                        reviewTextSmall: "6,393 Reviews",
                        subtext: "6,393 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "3.9",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹400 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Sahara Ganj Mall, Hazratganj, Lucknow",
                address: "{Rahim nagar outlet kitchen} ES 7 DS 50, Aliganj, Lucknow",
                localityUrl: "lucknow/restaurants/in/saharaganj-mall-hazratganj",
            },
            timing: {
                text: "Closes in 1 hour 51 minutes",
                color: "#e5521f",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTU3XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/lucknowi/",
                    name: "Lucknowi",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/biryani/",
                    name: "Biryani",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "37 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/grandson-of-tunday-kababi-khurram-nagar/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/grandson-of-tunday-kababi-khurram-nagar/order",
            clickActionDeeplink: "",
        },
        distance: "2.7 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800279","element_type":"listing","rank":10}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "40% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "3725+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800894,
            name: "Mubeen's",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/4/800894/3a0714eeafd6a9d526ebe0262cfec1f1_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/4/800894/3a0714eeafd6a9d526ebe0262cfec1f1_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.2",
                rating_text: "4.2",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "62.9K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.3",
                        reviewCount: "2,380",
                        reviewTextSmall: "2,380 Reviews",
                        subtext: "2,380 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.3",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.1",
                        reviewCount: "60.5K",
                        reviewTextSmall: "60.5K Reviews",
                        subtext: "60.5K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.1",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹300 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Chowk, Lucknow",
                address: "296/17, Hatasangi Beg Ward, Aasarfabad, Chowk, Lucknow",
                localityUrl: "lucknow/chowk-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "39 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/mubeens-chowk/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/mubeens-chowk/order",
            clickActionDeeplink: "",
        },
        distance: "4.3 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800894","element_type":"listing","rank":11}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "50% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "13350+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 18890035,
            name: "UBQ By Barbeque Nation",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/5/18890035/2d2b03b528e425b5250c2a4f0c6a27c3_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/5/18890035/2d2b03b528e425b5250c2a4f0c6a27c3_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "3.9",
                rating_text: "3.9",
                rating_subtitle: "Good",
                rating_color: "9ACD32",
                votes: "2,755",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "",
                        reviewCount: "0",
                        reviewTextSmall: "0 Reviews",
                        subtext: "Does not offer Dining",
                        color: "",
                        ratingV2: "-",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "grey",
                            tint: "500",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "3.9",
                        reviewCount: "2,755",
                        reviewTextSmall: "2,755 Reviews",
                        subtext: "2,755 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "3.9",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹400 for two",
            },
            cfo: {
                text: "₹250 for one",
            },
            locality: {
                name: "Riverside Mall, Gomti Nagar, Lucknow",
                address: "3rd Floor, Riverside Mall, Vipin Khand, Gomti Nagar, Lucknow",
                localityUrl: "lucknow/restaurants/in/riverside-mall-gomti-nagar",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/biryani/",
                    name: "Biryani",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTkzXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/bbq/",
                    name: "BBQ",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹250 for one",
            },
        },
        order: {
            deliveryTime: "43 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/ubq-by-barbeque-nation-gomti-nagar/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/ubq-by-barbeque-nation-gomti-nagar/order",
            clickActionDeeplink: "",
        },
        distance: "2.6 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"fd7de883-2194-490d-9aa5-b9795e196e39","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18890035","element_type":"listing","rank":12}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "20% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "1775+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 19181785,
            name: "Garden Bakery",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/5/19181785/b23c4294327431652c8124a5f56b9120_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/5/19181785/b23c4294327431652c8124a5f56b9120_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.1",
                rating_text: "4.1",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "6,860",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.0",
                        reviewCount: "182",
                        reviewTextSmall: "182 Reviews",
                        subtext: "182 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.0",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.2",
                        reviewCount: "6,678",
                        reviewTextSmall: "6,678 Reviews",
                        subtext: "6,678 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.2",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹800 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Indira Nagar, Lucknow",
                address: "B 1031, Behind Bhootnath Market, Indira Nagar, Lucknow",
                localityUrl: "lucknow/indira-nagar-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNVwiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/bakery/",
                    name: "Bakery",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/pizza/",
                    name: "Pizza",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA2NFwiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/pasta/",
                    name: "Pasta",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/desserts/",
                    name: "Desserts",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA0MFwiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/coffee/",
                    name: "Coffee",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "30 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/garden-bakery-indira-nagar/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/garden-bakery-indira-nagar/order",
            clickActionDeeplink: "",
        },
        distance: "3.5 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19181785","element_type":"listing","rank":1}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "Pro extra 10% OFF",
                color: {
                    tint: "600",
                    type: "pink",
                },
            },
            {
                text: "50% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "8075+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 18923813,
            name: "WOW! Momo",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/3/18689923/cc7cfcafbaa312b8e003ab60181246b0_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/3/18689923/cc7cfcafbaa312b8e003ab60181246b0_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "3.7",
                rating_text: "3.7",
                rating_subtitle: "Good",
                rating_color: "9ACD32",
                votes: "2,182",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "3.3",
                        reviewCount: "83",
                        reviewTextSmall: "83 Reviews",
                        subtext: "83 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "3.3",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "500",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.1",
                        reviewCount: "2,099",
                        reviewTextSmall: "2,099 Reviews",
                        subtext: "2,099 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.1",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹400 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address: "36/6 Sapru Marg, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA1MVwiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/momos/",
                    name: "Momos",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTNcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/tibetan/",
                    name: "Tibetan",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "29 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/wow-momo-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/wow-momo-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.2 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18923813","element_type":"listing","rank":2}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "50% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "1400+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 18941050,
            name: "Shri Surendra Bhojanalya",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/0/18941050/1b78d5497525ecd1a059dc79db3e1726_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/0/18941050/1b78d5497525ecd1a059dc79db3e1726_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "3.7",
                rating_text: "3.7",
                rating_subtitle: "Good",
                rating_color: "9ACD32",
                votes: "32.8K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "3.9",
                        reviewCount: "374",
                        reviewTextSmall: "374 Reviews",
                        subtext: "374 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "3.9",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "3.5",
                        reviewCount: "32.5K",
                        reviewTextSmall: "32.5K Reviews",
                        subtext: "32.5K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "3.5",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "500",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹300 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Aliganj, Lucknow",
                address:
                    "Tarhi Khana, Sitapur Road, Near Vidanchal Mandir, Aliganj, Lucknow",
                localityUrl: "lucknow/aliganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/south-indian/",
                    name: "South Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "42 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/shri-surendra-bhojanalya-aliganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/shri-surendra-bhojanalya-aliganj/order",
            clickActionDeeplink: "",
        },
        distance: "4.3 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18941050","element_type":"listing","rank":3}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "Pro extra 15% OFF",
                color: {
                    tint: "600",
                    type: "pink",
                },
            },
            {
                text: "60% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "21775+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800424,
            name: "Durgma Restaurant",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/4/800424/b55b1bb8a4ed117708e384ce934b3ac0_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/4/800424/b55b1bb8a4ed117708e384ce934b3ac0_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.0",
                rating_text: "4.0",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "16K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.1",
                        reviewCount: "435",
                        reviewTextSmall: "435 Reviews",
                        subtext: "435 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.1",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "3.9",
                        reviewCount: "15.6K",
                        reviewTextSmall: "15.6K Reviews",
                        subtext: "15.6K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "3.9",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹250 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Lalbagh, Lucknow",
                address: "Basement, Durgma Towers, Lalbagh, Lucknow",
                localityUrl: "lucknow/lalbagh-restaurants",
            },
            timing: {
                text: "Opens tomorrow at 9:05am",
                color: "#ab000d",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "35 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/durgma-restaurant-lalbagh/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/durgma-restaurant-lalbagh/order",
            clickActionDeeplink: "",
        },
        distance: "2.1 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800424","element_type":"listing","rank":4}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "40% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "4525+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 801203,
            name: "On High - Hotel Silvete",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/3/801203/df51bd1dff3997ad6f9a0de0365aeb0c_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/3/801203/df51bd1dff3997ad6f9a0de0365aeb0c_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.0",
                rating_text: "4.0",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "5,783",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.0",
                        reviewCount: "272",
                        reviewTextSmall: "272 Reviews",
                        subtext: "272 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.0",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.0",
                        reviewCount: "5,511",
                        reviewTextSmall: "5,511 Reviews",
                        subtext: "5,511 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.0",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹1,100 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address: "Hotel Silvete, 4 A, Rana Pratap Marg, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "Closes in 25 minutes",
                color: "#ab000d",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjI3XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/bar-food/",
                    name: "Bar Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/salad/",
                    name: "Salad",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "36 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/on-high-hotel-silvete-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/on-high-hotel-silvete-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"801203","element_type":"listing","rank":5}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "Pro extra 15% OFF",
                color: {
                    tint: "600",
                    type: "pink",
                },
            },
            {
                text: "60% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "2000+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 18893853,
            name: "The Belgian Waffle Co.",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/2/18639812/cfbda35382090ddbf5128a946c235f74_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/2/18639812/cfbda35382090ddbf5128a946c235f74_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.2",
                rating_text: "4.2",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "3,033",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.0",
                        reviewCount: "121",
                        reviewTextSmall: "121 Reviews",
                        subtext: "121 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.0",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.4",
                        reviewCount: "2,912",
                        reviewTextSmall: "2,912 Reviews",
                        subtext: "2,912 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.4",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹300 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address: "36/6Kha, Sapru Marg, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/desserts/",
                    name: "Desserts",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "36 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/the-belgian-waffle-co-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/the-belgian-waffle-co-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.2 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18893853","element_type":"listing","rank":6}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "20% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "1950+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 19316179,
            name: "NIC - Natural Ice Creams",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/5/19316175/022bf8e7feae2e092fa615e50798353b_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/5/19316175/022bf8e7feae2e092fa615e50798353b_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.4",
                rating_text: "4.4",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "2,162",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "",
                        reviewCount: "0",
                        reviewTextSmall: "0 Reviews",
                        subtext: "Does not offer Dining",
                        color: "",
                        ratingV2: "-",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "grey",
                            tint: "500",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.4",
                        reviewCount: "2,162",
                        reviewTextSmall: "2,162 Reviews",
                        subtext: "2,162 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.4",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹200 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address:
                    "43/124, B M Plaza, UGF Part 3 & 4, Naval Kishor Road, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjMzXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/ice-cream/",
                    name: "Ice Cream",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/desserts/",
                    name: "Desserts",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "24 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/nic-natural-ice-creams-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/nic-natural-ice-creams-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "1.8 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19316179","element_type":"listing","rank":7}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "Pro extra 15% OFF",
                color: {
                    tint: "600",
                    type: "pink",
                },
            },
            {
                text: "50% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "2900+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/695598f38d29d0e5d3f8ffe57cfdb94c1613145422.png",
                    aspect_ratio: 2.0625,
                },
                text: "Restaurant partner follows WHO protocol",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800151,
            name: "The Mughal's Dastarkhwan",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/1/800151/35c6b1eddbc2d50d830758151102009b_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/1/800151/35c6b1eddbc2d50d830758151102009b_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.4",
                rating_text: "4.4",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "5,267",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.7",
                        reviewCount: "1,027",
                        reviewTextSmall: "1,027 Reviews",
                        subtext: "1,027 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.7",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "800",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.1",
                        reviewCount: "4,240",
                        reviewTextSmall: "4,240 Reviews",
                        subtext: "4,240 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.1",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹700 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Lalbagh, Lucknow",
                address: "29, Near Royal Hotel Crossing, BN Road, Lalbagh, Lucknow",
                localityUrl: "lucknow/lalbagh-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTU3XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/lucknowi/",
                    name: "Lucknowi",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "41 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/the-mughals-dastarkhwan-lalbagh/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/the-mughals-dastarkhwan-lalbagh/order",
            clickActionDeeplink: "",
        },
        distance: "2.4 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800151","element_type":"listing","rank":8}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "₹75 OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "3050+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800600,
            name: "Wahid Biryani",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/0/800600/1481315fbf2acdf26c8d3ca281140e35_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/0/800600/1481315fbf2acdf26c8d3ca281140e35_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "3.9",
                rating_text: "3.9",
                rating_subtitle: "Good",
                rating_color: "9ACD32",
                votes: "23.3K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "4.0",
                        reviewCount: "1,020",
                        reviewTextSmall: "1,020 Reviews",
                        subtext: "1,020 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "4.0",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "3.7",
                        reviewCount: "22.2K",
                        reviewTextSmall: "22.2K Reviews",
                        subtext: "22.2K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "3.7",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹300 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Aminabad, Lucknow",
                address: "Naaz Cinema Road, Aminabad Market, Aminabad, Lucknow",
                localityUrl: "lucknow/aminabad-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/biryani/",
                    name: "Biryani",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/rolls/",
                    name: "Rolls",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "29 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/wahid-biryani-1-aminabad/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/wahid-biryani-1-aminabad/order",
            clickActionDeeplink: "",
        },
        distance: "2.9 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800600","element_type":"listing","rank":9}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "Pro extra 20% OFF",
                color: {
                    tint: "600",
                    type: "pink",
                },
            },
            {
                text: "30% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "3975+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 800242,
            name: "Aryan Family's Delight",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/2/800242/29d309820d18d91dc82b41e23d4cdf01_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/2/800242/29d309820d18d91dc82b41e23d4cdf01_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.1",
                rating_text: "4.1",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "4,091",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "3.9",
                        reviewCount: "716",
                        reviewTextSmall: "716 Reviews",
                        subtext: "716 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "3.9",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.2",
                        reviewCount: "3,375",
                        reviewTextSmall: "3,375 Reviews",
                        subtext: "3,375 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.2",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹800 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Hazratganj, Lucknow",
                address:
                    "Ground Floor, Aryan Building, M G Marg, Near Raj Bhavan, Hazratganj, Lucknow",
                localityUrl: "lucknow/hazratganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/chinese/",
                    name: "Chinese",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
                    name: "Fast Food",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/pizza/",
                    name: "Pizza",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/south-indian/",
                    name: "South Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/desserts/",
                    name: "Desserts",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/beverages/",
                    name: "Beverages",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "40 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/aryan-familys-delight-hazratganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/aryan-familys-delight-hazratganj/order",
            clickActionDeeplink: "",
        },
        distance: "2.3 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800242","element_type":"listing","rank":10}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "40% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "2150+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 19663876,
            name: "Dine Out City ( DOC)",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/6/19663876/40902c4d26bb33451173484826286932_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/6/19663876/40902c4d26bb33451173484826286932_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "4.0",
                rating_text: "4.0",
                rating_subtitle: "Very Good",
                rating_color: "5BA829",
                votes: "1,499",
                subtext: "REVIEW",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "3.8",
                        reviewCount: "45",
                        reviewTextSmall: "45 Reviews",
                        subtext: "45 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "3.8",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "4.1",
                        reviewCount: "1,454",
                        reviewTextSmall: "1,454 Reviews",
                        subtext: "1,454 Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "4.1",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "700",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹700 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Aliganj, Lucknow",
                address: "M 1/33, Sector B, Aliganj, Lucknow",
                localityUrl: "lucknow/aliganj-restaurants",
            },
            timing: {
                text: "",
                color: "",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/asian/",
                    name: "Asian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/pizza/",
                    name: "Pizza",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzNcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mexican/",
                    name: "Mexican",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNjBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/japanese/",
                    name: "Japanese",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/thai/",
                    name: "Thai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc3XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/sushi/",
                    name: "Sushi",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "41 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/dine-out-city-doc-aliganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/dine-out-city-doc-aliganj/order",
            clickActionDeeplink: "",
        },
        distance: "2.3 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19663876","element_type":"listing","rank":11}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "Pro extra 15% OFF",
                color: {
                    tint: "600",
                    type: "pink",
                },
            },
            {
                text: "60% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "3250+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
    {
        type: "restaurant",
        info: {
            resId: 18762498,
            name: "Mughlai The Taste",
            image: {
                url: "https://b.zmtcdn.com/data/pictures/chains/8/18762498/2c2eb6521957d4e16b08cb9f6f207462_o2_featured_v2.jpg",
            },
            o2FeaturedImage: {
                url: "https://b.zmtcdn.com/data/pictures/chains/8/18762498/2c2eb6521957d4e16b08cb9f6f207462_o2_featured_v2.jpg",
            },
            rating: {
                has_fake_reviews: 0,
                aggregate_rating: "3.9",
                rating_text: "3.9",
                rating_subtitle: "Good",
                rating_color: "9ACD32",
                votes: "40.5K",
                subtext: "REVIEWS",
                is_new: false,
            },
            ratingNew: {
                newlyOpenedObj: null,
                suspiciousReviewObj: null,
                ratings: {
                    DINING: {
                        rating_type: "DINING",
                        rating: "3.9",
                        reviewCount: "569",
                        reviewTextSmall: "569 Reviews",
                        subtext: "569 Dining Reviews",
                        color: "#1C1C1C",
                        ratingV2: "3.9",
                        subtitle: "DINING",
                        sideSubTitle: "Dining Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                    },
                    DELIVERY: {
                        rating_type: "DELIVERY",
                        rating: "3.9",
                        reviewCount: "39.9K",
                        reviewTextSmall: "39.9K Reviews",
                        subtext: "39.9K Delivery Reviews",
                        color: "#E23744",
                        ratingV2: "3.9",
                        subtitle: "DELIVERY",
                        sideSubTitle: "Delivery Reviews",
                        bgColorV2: {
                            type: "green",
                            tint: "600",
                        },
                        newOnDelivery: false,
                    },
                },
            },
            cft: {
                text: "₹450 for two",
            },
            cfo: {
                text: "₹100 for one",
            },
            locality: {
                name: "Aliganj, Lucknow",
                address:
                    "Shop B-24, 25, 26, 27, Dilkash Plaza, Puraniya Tiraha, Sitapur Road, Aliganj, Lucknow",
                localityUrl: "lucknow/aliganj-restaurants",
            },
            timing: {
                text: "Closes in 1 hour 25 minutes",
                color: "#e5521f",
            },
            cuisine: [
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
                    name: "Mughlai",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/biryani/",
                    name: "Biryani",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
                    url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
                    name: "North Indian",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTc4XCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/kebab/",
                    name: "Kebab",
                },
                {
                    deeplink:
                        "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
                    url: "https://www.zomato.com/lucknow/restaurants/desserts/",
                    name: "Desserts",
                },
            ],
            should_ban_ugc: false,
            costText: {
                text: "₹100 for one",
            },
        },
        order: {
            deliveryTime: "39 min",
            isServiceable: true,
            hasOnlineOrdering: true,
            actionInfo: {
                text: "Order Now",
                clickUrl: "/lucknow/mughlai-the-taste-aliganj/order",
            },
        },
        gold: [],
        takeaway: [],
        cardAction: {
            text: "",
            clickUrl: "/lucknow/mughlai-the-taste-aliganj/order",
            clickActionDeeplink: "",
        },
        distance: "4 km",
        isPromoted: false,
        promotedText: "",
        trackingData: [
            {
                table_name: "zsearch_events_log",
                payload:
                    '{"search_id":"57187494-d370-415c-9bd6-224623ecc952","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18762498","element_type":"listing","rank":12}',
                event_names: {
                    tap: '{"action":"tap"}',
                    impression: '{"action":"impression"}',
                },
            },
        ],
        allCTA: [],
        promoOffer: "",
        checkBulkOffers: true,
        bulkOffers: [
            {
                text: "Pro extra 20% OFF",
                color: {
                    tint: "600",
                    type: "pink",
                },
            },
            {
                text: "60% OFF",
                color: {
                    tint: "500",
                    type: "blue",
                },
            },
        ],
        isDisabled: false,
        bottomContainers: [
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png",
                },
                text: "7975+ orders placed from here recently",
            },
            {
                image: {
                    url: "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
                    aspect_ratio: 2.66666666667,
                },
                text: "Follows all Max Safety measures to ensure your food is safe",
            },
        ],
    },
];
